const DEFAULT_LINK_SELECTOR = ":is(h1, h2, h3, h4, h5, h6) a[href]";
const INTERACTIVE_SELECTOR = "a, button, input, select, textarea, label, summary";
const DRAG_THRESHOLD = 10;

export default {
	mounted(el, binding) {
		let pointerOrigin = null;
		let hadSelection = false;

		const onPointerDown = (event) => {
			pointerOrigin = { x: event.clientX, y: event.clientY };

			// Record whether a selection exists inside this block before the browser clears it.
			const selection = window.getSelection();
			hadSelection = selection.toString().length > 0 && el.contains(selection.anchorNode);
		};

		const onClick = (event) => {
			// Let genuine interactive descendants handle their own clicks.
			if (event.target.closest(INTERACTIVE_SELECTOR)) {
				return;
			}

			// Don't hijack a click that concluded a text selection.
			if (window.getSelection().toString().length > 0) {
				return;
			}

			// A click that only cleared a pre-existing selection shouldn't navigate.
			if (hadSelection) {
				return;
			}

			if (pointerOrigin) {
				const distance = Math.hypot(event.clientX - pointerOrigin.x, event.clientY - pointerOrigin.y);

				if (distance > DRAG_THRESHOLD) {
					return;
				}
			}

			// Only act on the primary (left) and auxiliary (middle) buttons.
			const primary = event.button === 0;
			const auxiliary = event.button === 1;

			if (!primary && !auxiliary) {
				return;
			}

			const link = el.querySelector(binding.value || DEFAULT_LINK_SELECTOR);

			if (!link) {
				return;
			}

			// Mirror native anchor behaviour for modifier and middle clicks.
			if (auxiliary || event.metaKey || event.ctrlKey || event.shiftKey || link.target === "_blank") {
				window.open(link.href, "_blank");
				return;
			}

			window.location.assign(link.href);
		};

		el._blockLink = { onPointerDown, onClick };
		el.classList.add("is-block-link");
		el.addEventListener("pointerdown", onPointerDown);
		el.addEventListener("click", onClick);
		el.addEventListener("auxclick", onClick);
	},

	unmounted(el) {
		const { onPointerDown, onClick } = el._blockLink;

		el.removeEventListener("pointerdown", onPointerDown);
		el.removeEventListener("click", onClick);
		el.removeEventListener("auxclick", onClick);
		delete el._blockLink;
	},
};
